import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionvalidateService } from 'src/app/Services/sessionvalidate.service';
import { EmployeeloginService } from 'src/app/Services/employeelogin.service';
import { UserData, EmployeeData } from 'src/app/Models/employee-and-user-data';

@Component({
  selector: 'app-faq-page',
  templateUrl: './faq-page.component.html',
  styleUrls: ['./faq-page.component.css'],
})
export class FAQPageComponent {
  userdata?: UserData;

  validsession: boolean | undefined;
  LoginData: any;
  employeeData?: EmployeeData;
  shpId: number | undefined;

  constructor(
    private sesssionvalidator: SessionvalidateService,
    private router: Router,
    private EmployeeLoginService: EmployeeloginService
  ) {
    // this.validsession = this.sesssionvalidator.validate();
    // if (this.validsession) {
    // } else {
    //   this.router.navigate(['/login']);
    // }
  }
  ngOnInit(): void {
    this.employeeData = JSON.parse(localStorage.getItem('eeinfo') || '{}');
    if (this.employeeData?.EmployeeNo != undefined) {
      this.checkLogin();
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
      } else {
        this.router.navigate(['/login']);
      }
    }
  }

  checkLogin() {
    this.LoginData = this.EmployeeLoginService.GetEmployeeLogin(
      this.employeeData?.EmployeeNo,
      this.employeeData?.LastName
    ).subscribe((LoginData) => this.setCheckLogin(LoginData));
  }

  setCheckLogin(resdata: any) {
    this.LoginData = resdata;
    if (this.LoginData.GetEmployeeLogin.Result.Status != 'A') {
      this.router.navigate(['/adminlogin']);
    } else {
      this.validsession = this.sesssionvalidator.validate();
      if (this.validsession) {
        this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
        this.shpId = this.userdata?.shipid!;
      } else {
        this.router.navigate(['/shipselect']);
      }
    }
  }
}
